import { Button, Dialog, DialogContent } from '@opositandopn/ui';
import classnames from 'classnames';

import AppImg from '../../../assets/images/5104ed51-729e-4642-8b72-a2fedea05c1e.webp';
import { useConfiguration } from '../../../context/ConfigurationContext';
import { useApp, useAppActions } from '../../../state/appStore';
import { BaseComponentProps } from '../../../types/base-component.types';

import styles from './GetPremiumPopup.module.scss';

function GetPremiumPopup({
  className,
  testId = 'ui-get-premium-popup',
}: BaseComponentProps) {
  const { configuration } = useConfiguration();
  const { showGetPremiumPopup } = useApp();
  const { setShowGetPremiumPopup } = useAppActions();

  const close = () => {
    setShowGetPremiumPopup(false);
  };

  const goPremium = () => {
    window.open(`${configuration.app?.pageUrl}/mi-cuenta/premium`, '_blank');
    close();
  };

  return (
    <Dialog
      open={showGetPremiumPopup}
      onOpenChange={(open) => {
        if (!open) {
          close();
        }
      }}
    >
      <DialogContent
        className={classnames(styles['main'], className)}
        testId={testId}
      >
        <div className={styles['text']}>
          <h1>¡Hazte Premium y prepárate para cumplir tu sueño!</h1>
          <span className={styles['description']}>
            Con <strong>Premium</strong> podrás acceder a todo el contenido de{' '}
            <strong>OpositandoPN</strong>
          </span>
        </div>
        <div className={styles['image-wrapper']} aria-hidden="true">
          <img className={styles['image']} src={AppImg} alt="" />
        </div>
        <div className={styles['actions']}>
          <Button
            className={styles['button']}
            variant="outline-danger"
            shadow
            onClick={close}
          >
            Cancelar
          </Button>
          <Button
            className={styles['button']}
            variant="premium"
            shadow
            onClick={goPremium}
          >
            Hazte Premium
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export { GetPremiumPopup };
